import { Subject, Subscription } from 'rxjs';
import { timeInterval } from 'rxjs/operators';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: ['timeout'],
    template: require('./touchable.html'),
})
export class Touchable extends Vue {
    public timeout: number;
    public touched = false;

    private touch$ = new Subject();
    private touchSubscription: Subscription;

    public onTouchStart(event: TouchEvent) {
        this.touched = true;
        this.touch$.next(event);
        this.touchSubscription = this.touch$
            .pipe(timeInterval())
            .subscribe(({ interval, value }) => {
                if ((value as TouchEvent).type === 'touchend') {
                    this.touched = false;
                    this.touchSubscription.unsubscribe();
                    if (interval > this.timeout) {
                        this.$emit('touchtimed');
                    }
                }
            });
    }

    public onTouchEnd(event: TouchEvent) {
        this.touched = false;
        this.touch$.next(event);
    }

    public onContextMenu(event: TouchEvent) {
        event.preventDefault();
        this.touched = false;
        this.touch$.next({
            ...event,
            type: 'touchend',
        });
    }

    public onTouchMove(event: TouchEvent) {
        this.touch$.next(event);
    }
}
